import { WplywContext } from "../../../../context/wplywContext";
import { useContext, useState } from "react";
import { Drawer, Button } from "antd";
import datetimeParser from "../../../../components/datetimeParser";

const LogsDrawer = () => {
    const { wplyw } = useContext(WplywContext);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    return (
        <>
            {/* Button to open the drawer */}
            <Button onClick={toggleDrawer}>
                Historia zmian
            </Button>

            {/* The Drawer component */}
            <Drawer
                title="Historia zmian"
                placement="right"
                onClose={toggleDrawer}
                open={isDrawerOpen}
                width={500}
            >
                {/* Content of the drawer */}
                <div>
                    {wplyw.wplyw_data.data.logs ? (
                        <div>
                            {wplyw.wplyw_data.data.logs.map((log) =>                             
                            <div style={{padding: '10px', boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.05)', borderRadius: '5px', marginBottom: '20px'}}>
                                <div style={{}}>
                                    <div style={{fontSize: '14px', color: 'rgba(0, 0, 0, 0.48)'}}>{log.msr_logs_label} (Etap: {log.msr_logs_step})</div>
                                    <div style={{fontSize: '16px', color: 'black'}}>{log.msr_logs_value}</div>
                                </div>
                                <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '8px', gap: '10px', justifyContent: 'space-between'}}>
                                    <div style={{fontSize: '14px', color: 'rgba(0, 0, 0, 0.48)'}}>
                                        <div style={{color: 'black', fontWeight: '14px'}}>{log?.userDetails?.mlg_users_fullname}</div>
                                        <div style={{color: 'black', fontWeight: '14px'}}>{datetimeParser(log.msr_logs_datetime, 'YYYY-MM-DD HH:mm')}</div>
                                    </div>
                                    <div style={{fontSize: '14px', color: 'rgba(0, 0, 0, 0.48)'}}>
                                        {log.msr_logs_object_own_id && log.msr_logs_object_own_id != 'null' ? <div style={{color: 'black', fontWeight: '14px', textAlign: 'right'}}>ID obiektu: #{log.msr_logs_object_own_id}</div> : <></>}
                                        {log.msr_persons_id ? <div style={{color: 'black', fontWeight: '14px', textAlign: 'right'}}>ID osoby: #{log.msr_persons_id}</div> : <></>}
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    ) : (
                        <p>Brak wpisów.</p>
                    )}
                </div>
            </Drawer>
        </>
    );
};

export default LogsDrawer;
